const getStateFromGeoCode = (
  lat: number, lng: number
) => {
  const myApiKey = process.env.REACT_APP_GOOGLE_KEY;
  const apiPrefix = "https://maps.googleapis.com/maps/api/geocode/json?address=";
  const stateKeywordInGoogleApi = "administrative_area_level_1";
  return new Promise((resolve, reject) => {
    fetch(apiPrefix + lat + ',' + lng + '&key=' + myApiKey,)
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.status === 'OK') {
          responseJson?.results.forEach((element: any) => {
            if (element.types.includes(stateKeywordInGoogleApi)) {
              (element.address_components.forEach((el: any) => {
                if (el.types.includes(stateKeywordInGoogleApi)) {
                  resolve({
                    name: el.long_name,
                    isoCode: el.short_name
                  }
                  )
                }
              }));
            }
          });
        } else {
          reject('not found');
        }
      })
      .catch(error => {
        reject(error);
      });
  });

};

export default getStateFromGeoCode;
